import { Pipe, PipeTransform } from '@angular/core';
import {AssetsService} from "../services/assets.service";

@Pipe({
  name: 'asset',
  standalone: true,
  pure: true,
})
export class AssetPipe implements PipeTransform {
  constructor(private assetService: AssetsService) {}

  transform(assetName: string): string {
    if (!assetName) {
      return '';
    }

    return this.assetService.getAsset(assetName);
  }
}
